// extracted by css-extract-rspack-plugin
export default {"titles":"k0ChS3GbgCQrnT3_","title":"z3vAGKJ4oT45fcCu","subTitle":"wrg1S8euUIcGWHjh"};